import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box,
  FormControl,
  Input,
  FormLabel,
  Divider,
  Checkbox,
  Tooltip,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { updateField } from "../../../../redux/actions/formActions";
import InputField from "./InputField";
const Address = ({ field, dispatchUpdateField }) => {
  const handleOnChange = (payload) => {
    const updateField = JSON.parse(JSON.stringify(field));
    if (payload.type == "child") {
      const { parentPropKey, childPropKey, value } = payload;
      updateField.fields[parentPropKey][childPropKey] = value;
      return dispatchUpdateField(updateField);
    }
    const { parentPropKey, value } = payload;
    updateField[parentPropKey] = value;
    dispatchUpdateField(updateField);
  };

  const renderAddressFields = () => {
    const addressFields = Object.entries(field.fields).map(([key, value]) => {
      return (
        <React.Fragment key={key}>
          <InputField
            field={value}
            parentKey={key}
            handleOnChange={handleOnChange}
          />
          <Divider mt="24px" />
        </React.Fragment>
      );
    });
    return addressFields;
  };
  const styleClasses = field.styleClasses.length
    ? field.styleClasses.join(" ")
    : "";
  return (
    <Box mt="16px" w="380px" h="333.93">
      <FormControl>
        <FormLabel fontSize="16px" fontWeight="600" color="#12344D" mb="14px">
          Address field settings
        </FormLabel>
        <Checkbox
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          isChecked={field.showLabel}
          onChange={(e) =>
            handleOnChange({
              value: e.target.checked,
              type: "parent",
              parentPropKey: "showLabel",
            })
          }
        >
          Show Address field labels
        </Checkbox>
      </FormControl>
      <FormControl mt="14px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867">
          Form css class{" "}
          <Tooltip
            label="Enter multiple css classes separated by space"
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
        </FormLabel>
        <Input
          mt="4px"
          w="378px"
          h="32px"
          borderRadius="4px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          type="text"
          value={styleClasses}
          placeholder="Enter css class name"
          onChange={(e) =>
            handleOnChange({
              value: e.target.value.split(" "),
              type: "parent",
              parentPropKey: "styleClasses",
            })
          }
        />
      </FormControl>
      <Divider mt="24px" />
      {renderAddressFields()}
    </Box>
  );
};

Address.propTypes = {
  field: PropTypes.object.isRequired,
  dispatchUpdateField: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateField: bindActionCreators(updateField, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(Address);
